module.exports = __webpack_public_path__ + "static/triangle_background-9df4fa2e10f0e294779511e99083c2bc.jpg";